import { Button, Col, Drawer, Form, Input, Row, Upload, UploadFile, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { ActionType } from "../../constants/actionType";
import { RcFile, UploadProps } from "antd/es/upload";
import { Icon } from "ts-react-feather-icons";
import {createSound, updateSound} from "../../helpers/api/sound";

const soundDrawerValidation = {
    name: [
        { required: true, message: "Name is required" },
        { max: 100, message: "Name must be less than 100 characters" },
    ],
};

const SoundDrawer = ({
                         drawerVisibility,
                         setdDrawerVisibility,
                         soundDetail,
                         setSoundDetail,
                         actionType,
                         setActionType,
                         onSuccess,
                         onFailure,
                     }: any) => {
    const [form] = Form.useForm();
    const [submittables, setSubmittable] = useState<boolean>(false);
    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

    const [sounds, setSounds] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewSound, setPreviewSound] = useState<string | undefined>("");
    const [previewTitle, setPreviewTitle] = useState("");

    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }
        setPreviewSound(file.url || (file.preview as string));
        setPreviewTitle(file.name || "Audio Preview");
        setPreviewOpen(true);
    };

    const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) =>
        setSounds(newFileList);

    const uploadButton = (
        <div>
            <Icon name="plus" size={16} />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    useEffect(() => {
        form.validateFields({ validateOnly: true })
            .then(() => setSubmittable(true))
            .catch(() => setSubmittable(false));
    }, [form]);

    useEffect(() => {
        if (actionType === ActionType.CREATE) {
            form.resetFields();
        }
    }, [actionType]);

    useEffect(() => {
        if (!soundDetail) {
            return;
        }
        if (soundDetail?.soundUrl && soundDetail?.soundUrl?.trim().length > 0) {
            const urlTemp = soundDetail?.soundUrl.split("/");
            setSounds([{
                uid: "1",
                name: urlTemp[urlTemp.length - 1],
                status: 'done',
                url: soundDetail?.soundUrl
            }]);
        }
        form.setFieldsValue({ ...soundDetail });
    }, [soundDetail]);

    const onClose = () => {
        form.resetFields();
        setSoundDetail(null);
        setSubmittable(false);
        setSounds([]);
        setdDrawerVisibility(false);
        setActionType("");
    }

    const saveSound = async () => {
        try {
            setLoadingBtn(true);

            const name = form.getFieldValue("name")?.trim();
            const requestModel: any = {
                name,
            };

            const fileToSend = sounds.length > 0 ? sounds[0].originFileObj : null;

            let response;
            if (actionType === ActionType.CREATE) {
                response = await createSound({
                    data: JSON.stringify(requestModel),
                    sound: fileToSend,
                });
            } else {
                const requestBody: any = {};
                if (sounds?.[0] && sounds?.[0].url === soundDetail.soundUrl) {
                    requestModel["soundUrl"] = soundDetail.soundUrl;
                } else {
                    requestBody["sound"] = sounds?.[0]?.originFileObj;
                }
                requestBody["data"] = JSON.stringify(requestModel);

                response = await updateSound(soundDetail.id, requestBody);
            }

            if (response?.status === 200) {
                onSuccess();
                onClose();
                return;
            }
        } catch (err) {
            console.error(err);
            onFailure(err);
        } finally {
            setLoadingBtn(false);
        }
    };

    return (
        <Drawer
            title={`${actionType === ActionType.UPDATE ? "Update" : "Create"} Sound`}
            className="outfit-drawer"
            width={850}
            onClose={onClose}
            open={drawerVisibility}
            closeIcon={false}
            footer={
                <div className="d-flex justify-content-center">
                    <Button
                        onClick={saveSound}
                        type="primary"
                        className="me-3"
                        // disabled={!submittables}
                        loading={loadingBtn}
                    >
                        Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </div>
            }
        >
            <Form layout="vertical" autoComplete="off" form={form}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="name"
                            label="Name"
                            rules={soundDrawerValidation.name}
                        >
                            <Input placeholder="Enter name" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="sound" label="Sound">
                            <Upload
                                listType="text"
                                accept="audio/*"
                                onPreview={handlePreview}
                                onChange={handleChange}
                                beforeUpload={() => false}
                                fileList={sounds}
                            >
                                {sounds.length >= 1 ? null : uploadButton}
                            </Upload>
                            <Modal
                                open={previewOpen}
                                title={previewTitle}
                                footer={null}
                                onCancel={handleCancel}
                            >
                                <audio controls style={{ width: "100%" }}>
                                    <source src={previewSound} type="audio/mpeg" />
                                    Your browser does not support the audio element.
                                </audio>
                            </Modal>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
};

export default SoundDrawer;
